import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import type { Option } from '../shared/types';
import { format, parse } from 'date-fns';

export const mapWithValueType = (options: Option[]): Option[] => {
  return options.map((field) => {
    if (field.children) {
      return {
        ...field,
        children: mapWithValueType(field.children),
      };
    }

    return {
      ...field,
      // Stores the value_type in the Item's value along with the id
      // so we know how to process the CustomField later
      id: `${field.id}__${field.value_type}`,
    };
  }) as Option[];
};

export const filterByTerm = (items: Item[], term: string) => {
  if (!term) {
    return items;
  }

  return items.filter((item) =>
    item.label.toLowerCase().includes(term.toLowerCase())
  );
};

export const parseDate = (
  val: string | null,
  userDateFormat: string | null
) => {
  if (!val || !userDateFormat) {
    return null;
  }

  return parse(val, userDateFormat, new Date());
};

export const formatDate = (
  date: Date | null,
  userDateFormat: string | null
) => {
  if (!date || !userDateFormat) {
    return null;
  }

  return format(date, userDateFormat);
};

export const formatShortDate = (
  dateString: string | null,
  userDateFormat: string | null
): string | null => {
  if (!dateString || !userDateFormat) {
    return null;
  }

  try {
    const parsedDate = parse(dateString, userDateFormat, new Date());

    let displayFormat: string;
    switch (userDateFormat) {
      case 'day_month_year':
        displayFormat = 'd LLL yyyy';
        break;
      case 'year_month_day':
        displayFormat = 'yyyy LLL d';
        break;
      default: // month_day_year
        displayFormat = 'LLL d, yyyy';
    }

    return format(parsedDate, displayFormat);
  } catch (error) {
    return dateString;
  }
};
